import {
  ActivatedOffersPageError,
  ActivatedOffersPageResult,
  ActivatedOffersPageResultTypenames,
  ActivatedOffersPageSuccess,
} from '@varo/graphql-schema-types';

export const isActivatedOffersPageSuccess = (
  activatedOffersPageResult: ActivatedOffersPageResult | undefined,
): activatedOffersPageResult is ActivatedOffersPageSuccess => {
  return (
    activatedOffersPageResult?.__typename ===
    ActivatedOffersPageResultTypenames.ActivatedOffersPageSuccess
  );
};

export const isActivatedOffersPageError = (
  activatedOffersPageResult: ActivatedOffersPageResult | undefined,
): activatedOffersPageResult is ActivatedOffersPageError => {
  return (
    activatedOffersPageResult?.__typename ===
    ActivatedOffersPageResultTypenames.ActivatedOffersPageError
  );
};
